export const manifest = {
  screens: {
    scr_t68d3c: { name: "Home", route: "/" },
  },
}
